import { Color } from 'shared/utils/colors';

export interface RenderableProcess {
  color: Color;
  code: string;
}

export enum ProcessIconSize {
  small = 'small',
  default = 'default',
  issueCard = 'issueCard',
}

export interface ProcessIconProps {
  color: Color;
  code: string;
  size?: ProcessIconSize;
  className?: string;
}
